import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NoSSR from '@r1-frontend/entities/Layout/_deps/helpers/noSSR';
import { openCitySelect } from '@r1-frontend/entities/Layout/CitySelectContainer/store/actionCreators';
import { getCurrentCity } from '@r1-frontend/entities/stores/city/selectors';

import * as ST from './styled';

export const ConfirmCitySelection = () => {
    const dispatch = useDispatch();
    const city = useSelector(getCurrentCity);
    const openCitySelectHandler = () => dispatch(openCitySelect());

    return <NoSSR>
        <ST.CityConfirmationBlock>
            <ST.StyledCitySelection
                city={city}
                onBackClick={openCitySelectHandler}
                data-test='city-selection'
            />
        </ST.CityConfirmationBlock>
    </NoSSR>;
};
